import { call, put } from 'redux-saga/effects';

import * as types from './task-simple.types';
import * as actions from './task-simple.actions';
import * as api from '../../api/request-config/task.api';

import { apiRequest } from '../../api/api.saga-services';
import { select } from '../../../utils/selector.utils';

import { taskSimpleSelectors } from './task-simple.selectors';
import { IUser } from '../user/user.types';

export function* storeTaskSimple(task: types.ITaskSimple | types.ITaskSimple[]) {
  yield put(actions.storeTaskSimple(task));
  return task;
}

export function* clearTaskSimple(taskId: types.ITaskSimple['id']) {
  yield put(actions.clearTaskSimple(taskId));
}

export function* clearAllTasksSimple() {
  const taskIds: types.ITaskSimple['id'][] = yield select(taskSimpleSelectors.selectResourceIds);
  yield put(actions.clearTaskSimple(taskIds));
}

/* This method sends api request and handle response */
export function* searchTasks(searchParams: types.ITaskSimpleSearchParams) {
  const tasks: types.ITaskSimple[] = yield call(apiRequest, api.searchTasksApi(searchParams));
  yield call(storeTaskSimple, tasks);
  return tasks;
}

export function* getMyTasks(searchParams: types.ITaskSimpleSearchParams) {
  const tasks: types.ITaskSimple[] = yield call(apiRequest, api.getMyTasksApi(searchParams));
  yield call(storeTaskSimple, tasks);
  return tasks;
}

export function* createTaskSimple(data: types.ITaskSimpleCreate) {
  const task = (yield call(apiRequest, api.createTaskApi(data))) as types.ITaskSimple;
  if (!task) {
    return;
  }
  yield call(storeTaskSimple, task);
  return task;
}

export function* deleteTaskSimple(taskId: types.ITaskSimple['id']) {
  yield call(clearTaskSimple, taskId);
  yield call(apiRequest, api.deleteTaskApi(taskId));
}

export function* saveTaskOrder(taskTypeId: string, data: types.ISaveTaskOrder) {
  const response = (yield call(apiRequest, api.updateTaskOrderApi(taskTypeId, data))) as unknown;
  if (!response) {
    return;
  }
  return response;
}

export function* getSharedTask(id: types.ITaskSimple['id']) {
  const task = (yield call(apiRequest, api.getSharedTaskApi(id))) as types.ITaskSimple;
  if (!task) {
    return;
  }
  yield call(storeTaskSimple, task);
  return task;
}

export function* getTaskWatchers(taskId: types.ITaskSimple['id']) {
  const task = yield call(apiRequest, api.getTaskWatchersApi(taskId));
  if (!task) {
    return;
  }
  return task;
}

export function* addTaskWatcher(taskId: types.ITaskSimple['id'], userIds: IUser['id'][]) {
  const task = yield call(apiRequest, api.addTaskWatcherApi(taskId, userIds));
  if (!task) {
    return;
  }
  //yield call(storeTaskSimple, task);
  return task;
}

export function* removeTaskWatcher(taskId: types.ITaskSimple['id'], userIds: IUser['id']) {
  const task = yield call(apiRequest, api.removeTaskWatcherApi(taskId, userIds));
  if (!task) {
    return;
  }
  //yield call(storeTaskSimple, task);
  return task;
}
